'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var bluebird = require('bluebird');
var _ = require('lodash');
var toastr = require('toastr');
function HolidaysAndSpecialsEventsPanelController($scope, $rootScope, hseDataRetrieverService, csvService, momentService) {
  $scope.gridId = 'holiday-and-special-events';
  $scope.gridData = [];
  $scope.loadData = function () {
    return hseDataRetrieverService.getEvents().then(function (data) {
      $scope.gridData = data;
      return data;
    });
  };
  $scope.refreshGrid = function () {
    $rootScope.$broadcast('grid:loadData:' + $scope.gridId);
  };
  $scope.customSaveValidation = function customSaveValidation(editedRows, gridData) {
    var editedRowsValidation = _.reduce(editedRows, function (acc, row) {
      return Boolean(acc && row.origin && row.destination && row.eventName && row.eventType && row.startDate && row.endDate);
    }, true);
    return editedRowsValidation ? verifyDatesDoNotOverlap(gridData) : false;
  };
  function verifyDatesDoNotOverlap(specialEvents) {
    if (specialEvents) {
      for (var first = 0; first < specialEvents.length; first++) {
        for (var second = first + 1; second < specialEvents.length; second++) {
          if (isMatchingMarketAndEventType(specialEvents[first], specialEvents[second]) && !hasDuplicateDateRange(specialEvents[first], specialEvents[second]) && isOverlapping(specialEvents[first], specialEvents[second])) {
            var validationResult = 'Overlapping date ranges detected between : \'' + specialEvents[first].eventName + '\' and \'' + specialEvents[second].eventName + '\' please rectify and try again';
            toastr.error(validationResult);
            return false;
          }
        }
      }
    }
    return true;
  }
  function hasDuplicateDateRange(specialEvent1, specialEvent2) {
    return Boolean(specialEvent1.startDate === specialEvent2.startDate && specialEvent1.endDate === specialEvent2.endDate);
  }
  function isMatchingMarketAndEventType(specialEvent1, specialEvent2) {
    return Boolean(specialEvent1.origin === specialEvent2.origin && specialEvent1.destination === specialEvent2.destination && specialEvent1.eventType === specialEvent2.eventType);
  }
  function isOverlapping(specialEvent1, specialEvent2) {
    var range1;
    var range2;
    var typeOfStartDate = (0, _typeof2["default"])(specialEvent1.startDate);
    if (typeOfStartDate === 'string') {
      var startDate1 = momentService.of(specialEvent1.startDate, momentService.FIELD.CREATED_DATE, momentService.FORMAT.DATE_ISO);
      var endDate1 = momentService.of(specialEvent1.endDate, momentService.FIELD.CREATED_DATE, momentService.FORMAT.DATE_ISO);
      var startDate2 = momentService.of(specialEvent2.startDate, momentService.FIELD.CREATED_DATE, momentService.FORMAT.DATE_ISO);
      var endDate2 = momentService.of(specialEvent2.endDate, momentService.FIELD.CREATED_DATE, momentService.FORMAT.DATE_ISO);
      range1 = startDate1.value.twix(endDate1.value);
      range2 = startDate2.value.twix(endDate2.value);
    } else {
      range1 = specialEvent1.startDate.value.twix(specialEvent1.endDate.value, true);
      range2 = specialEvent2.startDate.value.twix(specialEvent2.endDate.value, true);
    }
    return range1.overlaps(range2);
  }
  $scope.customRemove = function (rows) {
    return hseDataRetrieverService.removeEvents(rows).then($scope.loadData);
  };
  $scope.customSave = function customSave(editedRows) {
    if (_.isEmpty(editedRows)) {
      return bluebird.reject();
    }
    var payload = _.transform(editedRows, function (acc, row) {
      var transformedRow = hseDataRetrieverService.buildPayload(row, getNewEventId(row));
      acc.push(transformedRow);
      return acc;
    }, []);
    return hseDataRetrieverService.saveEvents(payload).then($scope.loadData);
  };
  $scope.makeExportToCsv = function (data) {
    csvService.exportToCSV(data);
  };
  function getNewEventId(row) {
    return _.chain($scope.gridData).filter({
      origin: row.origin,
      destination: row.destination
    }).map('eventId').map(_.toInteger).max() + 1;
  }
}
HolidaysAndSpecialsEventsPanelController.$inject = ['$scope', '$rootScope', 'HolidaysAndSpecialsEventsDataRetrieverService', 'HolidaysAndSpecialEventsCSVService', 'MomentService'];
module.exports = HolidaysAndSpecialsEventsPanelController;